export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bf018e136725a9cc474b174bdd9b570e.jpg"
          alt="Premium Automotive Service"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white space-y-4 sm:space-y-6 max-w-4xl mx-auto">
          <h1 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-light leading-tight tracking-wide">
            Mükemmelliğin Adresi
          </h1>
          <h2 className="font-sans text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-gray-300 tracking-wide px-4">
            Premium Araç Bakım ve Onarım Merkezi
          </h2>
          <p className="font-sans text-sm sm:text-base lg:text-lg text-gray-400 leading-relaxed max-w-2xl mx-auto pt-2 sm:pt-4 px-4">
            Premium araçlarınız için özel hizmetler sunuyoruz. Son teknoloji çözümlerimiz ve uzman ekibimizle yüksek kalite standartlarında servis hizmeti sağlıyoruz.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 pt-4 sm:pt-8 justify-center px-4">
            <button
              onClick={() => scrollToSection('appointment')}
              className="bg-white text-black px-8 sm:px-10 py-3 sm:py-4 font-sans text-sm font-medium tracking-wide hover:bg-gray-200 transition-all flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <span>RANDEVU ALIN</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="bg-transparent border border-white text-white px-8 sm:px-10 py-3 sm:py-4 font-sans text-sm font-medium tracking-wide hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              HİZMETLERİMİZ
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('services')}
          className="text-white opacity-60 hover:opacity-100 transition-opacity cursor-pointer"
        >
          <i className="ri-arrow-down-line text-2xl sm:text-3xl"></i>
        </button>
      </div>
    </section>
  );
}